<template>
    <div class="vital">
        <small class="text-muted" v-text="label"></small>
        <br>
        <span v-text="value"></span>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'GeneralInformationBlock',
        props: {
            label: {required: true},
            value: {required: true}
        }
    }
</script>
